import { TFunction } from 'i18next';
import * as Yup from 'yup';

import { TLanguage } from 'config/tenancy';
import { DOCUMENT_VALIDATORS } from 'shared/presentation/validations/common';
type TParams = {
  t: TFunction<'authentication'>;
  language: TLanguage;
};

export const PasswordRecoverySchema = ({ t, language }: TParams) =>
  Yup.object({
    document: Yup.string()
      .required(t('This field is required'))
      .test('document', t('Please, inform a valid document'), value => {
        if (!value) return false;

        const validator = DOCUMENT_VALIDATORS[language];

        return validator(value);
      }),
  });
